import styled from 'styled-components';
import { Dialog } from '../../feedback/Dialog';
import { Button } from '../../input/Button';

export const ProductRemoveFormButton = styled(Button)
    .withConfig({ displayName: 'ProductRemoveFormButton' })
    .attrs({
        width: '50%',
        size: 'l',
        variant: 'filled',
    })``;

export const ProductRemoveFormDialog = styled(Dialog)
    .withConfig({ displayName: 'ProductRemoveFormDialog' })
    .attrs({
        height: 'auto',
        borderRadius: 3,
    })``;
